import { createMemo, createSignal, For, Show } from "solid-js";
import { PageIndicator } from "~/js/components/pageIndicator";
import { getItem, ItemCard } from "~/js/items";
import { createPage } from "~/js/utils";
import { goToPreviousPage, numToValuta, showPage } from "~/script";
import type { Item, PageId } from "~/types";

interface DisplayWinningsOptions {
	title?: string;
	returnBtn: {
		page?: PageId;
		text?: string;
	};
	items: Item[];
	sortBy?: string;
}

const [winnings, setWinnings] = createSignal<DisplayWinningsOptions | null>(null);

export function displayWinnings(options: DisplayWinningsOptions) {
	setWinnings(options);
	showPage("winnings");
	return;
}

function Winnings() {
	const [currentPage, setCurrentPage] = createSignal(0);
	const itemsPerPage = 50;
	const sorted = createMemo(() => {
		return winnings()?.items.sort((n, t) => getItem(t).price - getItem(n).price);
	});

	return (
		<div>
			<Show
				fallback={
					<button class="button back-btn" onclick={() => goToPreviousPage()} type="button">
						Go back
					</button>
				}
				when={winnings()}
			>
				<button class="button back-btn" onclick={() => showPage(winnings()?.returnBtn.page || "inventory")} type="button">
					{winnings()?.returnBtn.text || "Go to inventory"}
				</button>
			</Show>
			<div class="center title">
				<h1>{winnings()?.title || "Winnings"}</h1>
			</div>
			<div class="center">
				<p class="winnings-value">{numToValuta(winnings()?.items.reduce((acc, item) => acc + item.price, 0) || 0, 2)}</p>
			</div>
			<Show fallback={<div class="winnings-list">Sorry, to keep up performance, you can't see winnings again!</div>} when={winnings()}>
				<div class="winnings-controls">
					<PageIndicator
						currentPage={currentPage}
						setPage={setCurrentPage}
						totalPages={() => Math.ceil((winnings()?.items.length || 0) / itemsPerPage)}
					/>
				</div>
				<div class="winnings-list">
					<For each={sorted()?.slice(currentPage() * itemsPerPage, (currentPage() + 1) * itemsPerPage)}>
						{(item) => <ItemCard clickable={true} item={item} />}
					</For>
				</div>
			</Show>
		</div>
	);
}

createPage(
	() => <Winnings />,
	"winnings",
	(n) => {
		if (n.page !== "winnings" && n.page !== "inspect" && n.page !== "about") setWinnings(null);
	},
);
